export default "__VITE_ASSET__CGMbz3dk__"